// src/project/data/triggers/confirmProductBuy.js
// POST /product/confirm/buying?group=ultraxeno
// Confirme un achat après paiement
import { buildActionUrl, RIDER_ENDPOINTS } from '../config/apiConfig'

export default {
  postUrl() {
    return buildActionUrl(RIDER_ENDPOINTS.PRODUCT_CONFIRM_BUY)
  },
  format(params) {
    if (!params.buyingId) throw new Error('buyingId requis pour confirmer un achat')
    return {
      id: params.buyingId,
    }
  },
  parse(raw = {}) {
    if (raw?.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 500,
        message: raw?.message || 'Erreur lors de la confirmation',
        data: null,
      }
    }
    return {
      statusCode: 200,
      message: raw?.message || 'Achat confirmé avec succès',
      data: raw?.data || null,
    }
  },
}
